export default __webpack_public_path__ + "static/media/slider-info-laptop-light-bottom.e63223f3.svg";